import {environmentConfig} from "@/config/enviromentConfig";
import axios from "axios";

const SAFARICOM_IDENTITY_URL = 'https://identity.safaricom.com/partner/api/v2/fetchMaskedMsisdn';

export default class SafaricomService {
    static async getToken() {
        const response = await axios.get(`${environmentConfig.safaricomService}/get-token`);
        return response.data;
    }

    static async getMsisdnViaHeaderEnrichment() {
        try {
            console.log('[saf-ke-en] HE: Calling backend proxy for header enrichment...');
            const response = await axios.get(`${environmentConfig.safaricomService}/get-msisdn-via-he`);
            const data = response.data;
            if (data.msisdn) {
                console.log('[saf-ke-en] HE: MSISDN resolved via backend proxy');
                return {msisdn: data.msisdn};
            }
            console.log('[saf-ke-en] HE: Backend returned no MSISDN:', data);
            return {error: true};
        } catch (error) {
            console.log('[saf-ke-en] HE: Backend proxy call failed:', error.response?.data || error.message);
            return {error: true};
        }
    }

    static async updateUsername(msisdn, username, productId) {
        return await axios.post(`${environmentConfig.safaricomService}/update-username`, {
            msisdn: msisdn,
            username: username,
            productId: productId
        })
    }

    static async getUser(msisdn, productId) {
        return await axios.post(`${environmentConfig.safaricomService}/get-user`, {
                msisdn: msisdn,
                productId: productId,
            },
        )
    }

    // DIY Platform Query Active Subscriptions — returns { header, body: [...] }.
    // A non-empty body means the msisdn has an active DIY subscription with Safaricom.
    static async queryActiveSubscription(msisdn) {
        return await axios.get(`${environmentConfig.safaricomService}/query-active-subscription`, {
            params: {msisdn: msisdn},
        })
    }

    static async requestOtp(msisdn, productId) {
        return await axios.post(`${environmentConfig.safaricomService}/request-otp`, {
                msisdn: msisdn,
                productId: productId,
            },
        )
    }

    static async validateOtp(msisdn, productId, otp) {
        return await axios.post(`${environmentConfig.safaricomService}/validate-otp`, {
            msisdn: msisdn,
            productId: productId,
            otp: otp,
        })
    }

    static async unsubscribe(requestId, channel, msisdn, offerCode) {
        return await axios.post(`${environmentConfig.safaricomService}/unsubscribe`, {
            requestId,
            channel,
            msisdn,
            offerCode
        })
    }
}
